module.exports = __webpack_public_path__ + "static/img/bg41.dfcb4ece.png";